import * as XLSX from 'xlsx';
import RestbestandRow from '../models/RestbestandRow';
import RestbestandResponse from '../models/RestbestandResponse';

/** One tab per Restbestand quadrant, matching the sheet name limit (31 chars) and the columns
 * actually rendered in RestbestandSectionTable (Barcode / Status / Status-Zeitpunkt). */
const SHEETS: { key: keyof RestbestandResponse; title: string }[] = [
  { key: 'liegengebliebene', title: 'Liegengebliebene' },
  { key: 'lagernde', title: 'Lagernde' },
  { key: 'afnus', title: 'AFNUS' },
  { key: 'bereinigung', title: 'Bestandsbereinigung' },
];

function toSheetRows(rows: RestbestandRow[]) {
  return rows.map((row) => ({
    Barcode: row.barcode,
    Status: row.status,
    'Status-Zeitpunkt': row.statusZeitpunkt ?? '',
  }));
}

/** Exports all 4 Restbestand quadrants as separate tabs of a single .xlsx workbook. */
export function exportRestbestandToExcel(data: RestbestandResponse, orgId: number | string, datum: string): void {
  const workbook = XLSX.utils.book_new();

  SHEETS.forEach(({ key, title }) => {
    const rows = data[key] as RestbestandRow[];
    const worksheet = XLSX.utils.json_to_sheet(toSheetRows(rows));
    worksheet['!cols'] = [{ wch: 22 }, { wch: 28 }, { wch: 20 }];
    XLSX.utils.book_append_sheet(workbook, worksheet, title);
  });

  XLSX.writeFile(workbook, `Restbestand_${orgId}_${datum}.xlsx`, { bookType: 'xlsx' });
}
